import React from 'react';
import { SocketContext } from 'components/context/Socket';
import { isFunc } from 'vdlib';

const useOnlineAuctions = (
  onLiveAuctionStarted,
  onLiveAuctionEnded,
  onLiveAuctionOutbid
) => {
  const ctx = React.useContext(SocketContext);

  React.useEffect(() => {
    if (
      ctx &&
      ctx.connected &&
      isFunc(onLiveAuctionStarted) &&
      isFunc(onLiveAuctionOutbid) &&
      isFunc(onLiveAuctionEnded)
    ) {
      ctx.subscribe('auction-started', onLiveAuctionStarted);
      ctx.subscribe('auction-ended', onLiveAuctionEnded);
      ctx.subscribe('bid-placed', onLiveAuctionOutbid);
    }
  }, [ctx]); //eslint-disable-line

  return ctx;
};

export { useOnlineAuctions };
